<div class="payment" *ngIf="payments && payments.length">
  <div class="payment-label">{{ 'ORDERS.PAYMENT' | translate }}</div>
  <div class="payment-status">{{'ORDERS.PAYMENT_STATUS' | translate}}
    : {{ payments[0].isPaid | isPaid | translate}}</div>
  <div class="payment-type">{{'ORDERS.PAYMENT_TYPE' | translate}}
    : {{ paymentMapper(payments[0].type) | translate}}</div>
</div>
